"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTableSortState = exports.parseDataGridSortState = exports.buildTableSortStateFromUISort = exports.buildSortStateFromUIDataGridSort = void 0;
const table_columns_1 = require("../table-columns");
const buildSortStateFromUIDataGridSort = (sortModel) => {
    if (sortModel.length === 0) {
        return null;
    }
    const { field, sort } = sortModel[0];
    const { label, dataMeta: { isAIEnriched } } = (0, table_columns_1.parseColumnId)(field);
    return {
        key: label,
        direction: sort === 'asc' ? 0 /* SortDirection.Ascending */ : 1 /* SortDirection.Descending */,
        isAIEnriched,
    };
};
exports.buildSortStateFromUIDataGridSort = buildSortStateFromUIDataGridSort;
/** @deprecated */
const buildTableSortStateFromUISort = ({ key, direction }) => {
    const { label: id, dataMeta: { isAIEnriched } } = (0, table_columns_1.parseColumnId)(key);
    return {
        key: id,
        direction,
        isAIEnriched,
    };
};
exports.buildTableSortStateFromUISort = buildTableSortStateFromUISort;
const parseDataGridSortState = (tableSort) => {
    if (!tableSort) {
        return [];
    }
    const { key, isAIEnriched, direction } = tableSort;
    const id = (0, table_columns_1.createColumnId)(key, { isAIEnriched });
    return [{
            field: id,
            sort: direction === 0 /* SortDirection.Ascending */ ? 'asc' : 'desc',
        }];
};
exports.parseDataGridSortState = parseDataGridSortState;
/** @deprecated */
const parseTableSortState = (_a) => {
    var { key, isAIEnriched } = _a, tableSort = __rest(_a, ["key", "isAIEnriched"]);
    const id = (0, table_columns_1.createColumnId)(key, { isAIEnriched });
    return Object.assign({ key: id }, tableSort);
};
exports.parseTableSortState = parseTableSortState;
